import {useEffect} from "react";

import {
    HOME_MATCH_PREFERENCES_WIZARD_EXIT_STEP,
    HomeMatchAmplitudeLocation,
    HomeMatchAmplitudeTracker,
    HomeMatchPreferencesWizardAmplitudeButton
} from "@/features/tracking/amplitude/home_match_amplitude_tracker";

interface IParams {
    amplitudeLocation: HomeMatchAmplitudeLocation;
    isExitOpen: boolean;
    isOpen: boolean;
    trackedStep?: string;
}

// Tracks step and exit-prompt views; returns a click tracker bound to the current step (or an explicit one).
export const useHomeMatchPreferencesWizardTracking = (params: IParams) => {
    const {amplitudeLocation, isExitOpen, isOpen, trackedStep} = params;

    useEffect(() => {
        if (!isOpen || !trackedStep) return;

        HomeMatchAmplitudeTracker.preferencesWizardView(trackedStep, amplitudeLocation);
    }, [amplitudeLocation, isOpen, trackedStep]);

    useEffect(() => {
        if (!isOpen || !isExitOpen) return;

        HomeMatchAmplitudeTracker.preferencesWizardView(HOME_MATCH_PREFERENCES_WIZARD_EXIT_STEP, amplitudeLocation);
    }, [amplitudeLocation, isExitOpen, isOpen]);

    return (button: HomeMatchPreferencesWizardAmplitudeButton, step = trackedStep) => {
        if (!step) return;

        HomeMatchAmplitudeTracker.preferencesWizardClick(button, step, amplitudeLocation);
    };
};
import {useEffect} from "react";

import {
    HOME_MATCH_PREFERENCES_WIZARD_EXIT_STEP,
    HomeMatchAmplitudeLocation,
    HomeMatchAmplitudeTracker,
    HomeMatchPreferencesWizardAmplitudeButton
} from "@/features/tracking/amplitude/home_match_amplitude_tracker";

interface IParams {
    amplitudeLocation: HomeMatchAmplitudeLocation;
    isExitOpen: boolean;
    isOpen: boolean;
    trackedStep?: string;
}

// Tracks step and exit-prompt views; returns a click tracker bound to the current step (or an explicit one).
export const useHomeMatchPreferencesWizardTracking = (params: IParams) => {
    const {amplitudeLocation, isExitOpen, isOpen, trackedStep} = params;

    useEffect(() => {
        if (!isOpen || !trackedStep) return;

        HomeMatchAmplitudeTracker.preferencesWizardView(trackedStep, amplitudeLocation);
    }, [amplitudeLocation, isOpen, trackedStep]);

    useEffect(() => {
        if (!isOpen || !isExitOpen) return;

        HomeMatchAmplitudeTracker.preferencesWizardView(HOME_MATCH_PREFERENCES_WIZARD_EXIT_STEP, amplitudeLocation);
    }, [amplitudeLocation, isExitOpen, isOpen]);

    return (button: HomeMatchPreferencesWizardAmplitudeButton, step = trackedStep) => {
        if (!step) return;

        HomeMatchAmplitudeTracker.preferencesWizardClick(button, step, amplitudeLocation);
    };
};
